module.exports = __webpack_public_path__ + "static/media/backgroundImage.914c7b7e.jpg";